<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">صفحات داینامیک</h1>
          <div class="my-2">
            <b-table
              ref="refUserListTable"
              class="position-relative"
              :items="dynamicPagesList"
              responsive
              :fields="myTableColumns"
              primary-key="id"
              show-empty
              bordered
              striped
              empty-text="موردی موجود نیست!"
            >
              <!-- eslint-disable-next-line -->
              <template #cell(actions)="data">
                <b-link
                  :to="`/apps/dynamic-pages/${data.item.seourl}/${data.item.dynamicPageId}`"
                >
                  <feather-icon
                    size="20"
                    icon="EyeIcon"
                    style="cursor: pointer"
                    class="text-primary"
                  />
                </b-link>
              </template>
            </b-table>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end py-2"
            >
              <b-pagination
                v-model="pageNumber"
                :total-rows="totalCount"
                :per-page="count"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    style="transform: rotate(180deg)"
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
export default {
  data() {
    return {
      isLoading: false,
      count: 10,
      pageNumber: 1,
      totalCount: null,
      dynamicPagesList: null,
      myTableColumns: [
        {
          key: "dynamicPageId",
          label: "شناسه صفحه",
        },
        {
          key: "persianTitle",
          label: "نام صفحه",
        },
        {
          key: "title",
          label: "عنوان صفحه",
        },
        {
          key: "actions",
          label: "جزئیات",
        },
      ],
    };
  },
  mounted() {
    this.getAllDynamicPages();
  },
  watch: {
    pageNumber(val) {
      this.getAllDynamicPages();
    },
  },
  methods: {
    async getAllDynamicPages() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllDynamicPages = new GetAllDynamicPages(_this);
        getAllDynamicPages.setRequestParam({
          count: _this.count,
          pageNumber: _this.pageNumber,
        });
        await getAllDynamicPages.fetch((response) => {
          if (response.isSuccess) {
            _this.totalCount = response.data.dynamicPagesCount;
            _this.dynamicPagesList = response.data.dynamicPages;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },

  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BLink,
    BPagination,
    BOverlay,
    vSelect,
  },
};
import { GetAllDynamicPages } from "@/libs/Api/DynamicPages";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BLink,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
</script>
